<script>
    import { sgettext } from '../../i18n.js';
    import { afterUpdate } from 'svelte';
    export let row = {};

    let filterContainer;
    let isOverflowing = false;

    $: d2Filters = row.configured_filters.reduce((grp, filter) => {
        if (!grp[filter.filter_display_name]) {
            grp[filter.filter_display_name] = [];
        }
        grp[filter.filter_display_name].push(filter.filter_value);
        return grp;
    }, {});

    afterUpdate(() => {
        if (filterContainer) {
            isOverflowing = filterContainer.scrollHeight > 100;
        }
    });
</script>

{#if row.configured_filters && row.configured_filters.length}
  <div bind:this={filterContainer} class="filter-container">
    {#each Object.entries(d2Filters) as [key, values]}
      <div class="group">
        <span class="filter-key">{key}:</span>
        <div class="filter-values">
          {#each values as value}
            • {value}<br />
          {/each}
        </div>
      </div>
    {/each}
    {#if isOverflowing}
      <div class="more-indicator">...</div>
    {/if}
  </div>
{:else}
  <p>{sgettext('$$FILTERS_CONFIGURED$$')}</p>
{/if}

<style>
  .filter-container {
    max-height: 100px;
    overflow: hidden;
    position: relative;
    transition: max-height 0.3s ease-in-out;
  }

  .more-indicator {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.5rem;
    color: #7d7d7d;
  }

  .filter-container:hover {
    max-height: none;
  }

  .filter-container:hover .more-indicator {
    display: none;
  }

  .group {
    margin-bottom: 1rem;
  }

  .filter-key {
    font-weight: bold;
  }

  .filter-values {
    margin-left: 1rem;
    margin-top: 0.5rem;
  }
</style>
